<template>
  <header>
    <div id="logo-col" class="float-left">
      <img id="logo" width="200" height="35" alt="Park and Pedal logo" src="../assets/pp400x70.png">
    </div>
    <div id="console-title-col">Retail Console</div>
  </header>
</template>


<script>
export default {
  name: 'Header',
}
</script>


<style scoped>
header {
  width: 100%;
  height: 65px;
  padding: 5px 0;
}

#logo {
  margin: 10px;
}
#logo-col {
  width: 225px;
}

#console-title-col {
  padding-top: 18px;
  padding-bottom: 13px;
  line-height: 24px;
  font-size: 24px;
  vertical-align:  
}
</style>
